import VirtusoList from './VirtuosoList';

export default VirtusoList;
